import { render, staticRenderFns } from "./addcgLlist.vue?vue&type=template&id=51f0e224&scoped=true&"
import script from "./addcgLlist.vue?vue&type=script&lang=js&"
export * from "./addcgLlist.vue?vue&type=script&lang=js&"
import style0 from "./addcgLlist.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addcgLlist.vue?vue&type=style&index=1&id=51f0e224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f0e224",
  null
  
)

export default component.exports